import styled from '@emotion/styled';
import { useChatPopover } from './hooks';
import Popover from 'presentations/views/components/atoms/Popover';
import { borderRadius, mediaMax, zIndex } from 'presentations/views/styles';
import { ViewerItem } from 'presentations/api/schema/user';
import { blueGrayPale, gray02, gray04 } from 'presentations/views/styles/color';
import HomeView from './HomeView';
import SummarizeView from './SummarizeView';
import ScheduleView from './ScheduleView';
import OptimizeView from './OptimizeView';
import AssistantOnboard from 'presentations/views/components/organisms/AssistantOnboard';
import PlanUpgradeDialog from 'presentations/views/components/organisms/PlanUpgradeDialog';
// import RecommendView from './RecommendView';
import { ActiveIndex } from 'presentations/reducers/AssistantWidget';
import ConversationView from './ConversationView';

interface Props {
  viewer: ViewerItem;
  anchor: HTMLElement | null;
}

export default function Component(props: Props) {
  const { state, actions } = useChatPopover({ isOpen: !!props.anchor });

  if (state.isShowUpgrade) {
    return <PlanUpgradeDialog onClose={actions.onCloseUpgrade} />;
  }
  if (state.isShowOnboard) {
    return (
      <AssistantOnboard
        viewer={props.viewer}
        onClose={actions.onCloseOnboard}
        onSubmit={actions.onAvailable}
      />
    );
  }
  if (!state.isAvailable) {
    return null;
  }

  return (
    <StyledPopover
      anchor={props.anchor}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={actions.onClose}
      transition="grow"
      isKeepMounted
    >
      {state.activeIndex === ActiveIndex.Top ? (
        <HomeView
          viewer={props.viewer}
          onClickBack={actions.onClose}
          onClickPresetView={actions.onClickPresetView}
          onSubmitMessage={actions.onSubmitMessage}
        />
      ) : state.activeIndex === ActiveIndex.Conversation ? (
        <ConversationView
          viewer={props.viewer}
          onClickBack={actions.onClickBack}
          defaultContent={state.defaultConversationMessage}
        />
      ) : state.activeIndex === ActiveIndex.SummaryChat ? (
        <SummarizeView
          viewer={props.viewer}
          onClickBack={actions.onClickBack}
        />
      ) : state.activeIndex === ActiveIndex.OptimizeChat ? (
        <OptimizeView viewer={props.viewer} onClickBack={actions.onClickBack} />
      ) : (
        [
          ActiveIndex.ScheduleChat,
          ActiveIndex.ScheduleChatSelectUser,
          ActiveIndex.ScheduleChatMessage,
        ].includes(state.activeIndex) && (
          <ScheduleView
            viewer={props.viewer}
            onClickBack={actions.onClickBack}
          />
        )
      )}
      {/* {state.activeIndex === ActiveIndex.RecommendChat && (
        <RecommendView
          viewer={props.viewer}
          viewerBlocks={props.viewerBlocks}
          calendarDateList={props.calendarDateList}
        />
      )} */}
    </StyledPopover>
  );
}

const StyledPopover = styled(Popover)`
  z-index: ${zIndex(1300)};
  .MuiPaper-root {
    width: 540px;
    border-radius: ${borderRadius(16)};
    background-color: ${blueGrayPale};
    border: 1px solid ${gray04};
    overflow-y: hidden;
    ${mediaMax.tablet} {
      overflow-y: auto;
      min-width: auto;
      max-width: initial;
      max-height: initial;
      width: 100vw;
      height: 100vh;
      padding-bottom: 56px;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      border-radius: 0 !important;
      border: 0 !important;
    }
  }
`;
